import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import { throttle, isMobile } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import { getApiDatas } from "../../utilities/FrontFunctions/AoxFrontFunctions"

import ObjParcours from '../inc/ObjParcours'

class ObjPushParcours extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: isMobile(),
        }
        this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
        this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
    }
    handleWindowResizeMainHeader() {
        this.setState({
            isMobile: isMobile()
        })
    }
    componentDidMount() {
        if(this.props.fields?.Parcours){
            getApiDatas(`/apiaox/Call/PushParcours?id=${this.props.fields?.Parcours.id}`).then((apiDatas) => { 
                this.setState({ apiDatas:apiDatas }) 
                window.scrollTo(0,0)
            })
        }
    }

    //juste un "emballage" du composant ObjParcours récupérant de lui-même les datas Sitecore et API
    render() {
        const scFields = this.props.fields;
        const { apiDatas } = this.state;
        return (<>{ apiDatas?.Parcours && <>
            <ObjParcours datasParcours={apiDatas.Parcours} scFields={scFields}/>
        </>}</>)
    }
}

export default withTranslation()(withSitecoreContext()(ObjPushParcours));